import { render, staticRenderFns } from "./NewAddPointsAction.vue?vue&type=template&id=6bf0c6f2&"
import script from "./NewAddPointsAction.vue?vue&type=script&lang=js&"
export * from "./NewAddPointsAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports